<template>
  <div>
    <div class="invite-search">
      <input
        type="text"
        class="input"
        :placeholder="$t('profile.gameSearch')"
      />
    </div>
    <ul class="invite-list">
      <!-- <li
                @click="invite(2, id)"
                class="invite-item"
                :class="{'disabled': inviteToGameLoader}"
            >
                <div class="invite-img no-image"></div>
                <div class="invite-title">Русская рулетка</div>
            </li> -->
      <li
        @click="invite(1, id)"
        class="invite-item"
        :class="{ disabled: inviteToGameLoader }"
      >
        <div class="invite-img no-image"></div>
        <div class="invite-title">
          {{ $t("games.yesNo") }}
        </div>
      </li>
      <li
        @click="invite(3, id)"
        class="invite-item"
        :class="{ disabled: inviteToGameLoader }"
      >
        <div class="invite-img no-image"></div>
        <div class="invite-title">
          {{ $t("games.twistingTurning") }}
        </div>
      </li>
      <li
        @click="invite(4, id)"
        class="invite-item"
        :class="{ disabled: inviteToGameLoader }"
      >
        <div class="invite-img no-image"></div>
        <div class="invite-title">
          {{ $t("games.theUndressingFool") }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "InviteToGame",
  props: {
    i18n: Object,
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      inviteToGameLoader: false,
      games: ["yes-no", "russian-roulette", "shell-game", "durak"],
    };
  },
  computed: {
    ...mapGetters({
      myLobby: "game/fetchMyLobby",
      init: "init/fetchInit",
      initIsEmpty: "init/isEmpty",
      userIsEmpty: "user/isEmpty",
    }),
  },
  methods: {
    invite(gameId, userId) {
      if (this.userIsEmpty("user")) {
        this.$modal.show("welcome");
        return;
      }
      this.inviteToGameLoader = true;
      let data = {
        game: gameId,
        name: "",
        private: 1,
      };
      if (gameId == 2) {
        data.bet = this.init.costs.game_2_base_bet;
      }
      this.$store
        .dispatch("game/create", data)
        .then(() => {
          this.$store
            .dispatch("game/invite", userId)
            .then(() => {
              this.inviteToGameLoader = false;
              // Уведомление об успешном приглашении
              this.$notify({
                type: "success",
                text: this.$t("games.inviteSent"),
              });
              // Переход на страницу игры с lobbyId
              this.$router.push({
                name: "game",
                params: {
                  id: gameId,
                  lobbyId: this.myLobby.id,
                },
              });
            })
            .catch((error) => {
              this.inviteToGameLoader = false;
              // Показываем реальную ошибку от сервера
              const errors = this.$store.state.game.errors;
              const errorText = (errors && errors.non_field_errors && errors.non_field_errors[0]) 
                || this.$t("games.inviteError");
              console.error('Invite error:', errors);
              this.$notify({
                type: "error",
                text: errorText,
              });
            });
        })
        .catch((error) => {
          this.inviteToGameLoader = false;
          // Показываем реальную ошибку от сервера
          console.log('Caught error:', error);
          console.log('Error type:', typeof error);
          console.log('Error.data:', error ? error.data : 'no error');
          console.log('Store errors:', this.$store.state.game.errors);
          
          const errors = this.$store.state.game.errors;
          const errorText = (errors && errors.non_field_errors && errors.non_field_errors[0]) 
            || this.$t("games.createLobbyError");
          console.error('Create lobby error:', errors);
          this.$notify({
            type: "error",
            text: errorText,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_invite";
</style>
